import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { userAPI } from '../api';
import { FiPhone, FiLock, FiSave, FiAward, FiTrendingUp, FiUser } from 'react-icons/fi';

const Profile = () => {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    fullName: user?.fullName || '',
    level: user?.level || 'beginner'
  });
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const res = await userAPI.updateProfile(formData);
      updateUser(res.data.user);
      setMessage({ type: 'success', text: 'Profile updated successfully!' });
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.message || 'Failed to update profile' });
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (passwords.newPassword !== passwords.confirmPassword) {
      setMessage({ type: 'error', text: 'New passwords do not match' });
      return;
    }

    if (passwords.newPassword.length < 6) {
      setMessage({ type: 'error', text: 'Password must be at least 6 characters' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await userAPI.updatePassword({
        currentPassword: passwords.currentPassword,
        newPassword: passwords.newPassword
      });
      setMessage({ type: 'success', text: 'Password updated successfully!' });
      setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.message || 'Failed to update password' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: '100vh', backgroundColor: '#ffffff', color: '#1a2b4c', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      {/* 导航栏 */}
      <nav style={{ 
        position: 'fixed', 
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000, 
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        backdropFilter: 'blur(10px)',
        height: '64px',
        minHeight: '64px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center'
      }}>
        <style>{`
          @media (max-width: 1024px) {
            .nav-left-area {
              gap: 0.35rem !important;
            }
            .nav-logo-123, .nav-logo-wonder {
              font-size: 1.6rem !important;
            }
            .nav-category-label {
              font-size: clamp(0.8rem, 2.2vw, 1.1rem) !important;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 40vw;
            }
          }
          @media (max-width: 768px) {
            .nav-left-area {
              gap: 0.25rem !important;
            }
            .nav-logo-123, .nav-logo-wonder {
              font-size: 1.4rem !important;
            }
            .nav-category-label {
              font-size: clamp(0.75rem, 2vw, 1rem) !important;
              max-width: 35vw;
            }
          }
          @media (max-width: 480px) {
            .nav-logo-123, .nav-logo-wonder {
              font-size: 1.2rem !important;
            }
            .nav-category-label {
              font-size: clamp(0.7rem, 1.8vw, 0.9rem) !important;
              max-width: 32vw;
            }
          }
        `}</style>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          margin: '0 auto',
          padding: '0 1rem',
          boxSizing: 'border-box'
        }}>
          {/* 左侧区域 - Logo */}
          <div className="nav-left-area" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center',
                textDecoration: 'none',
                color: '#333333',
                cursor: 'pointer',
                minWidth: 0,
                flexShrink: 1
              }}
              onClick={() => navigate('/')}
            >
              <img 
                src="/logo.png" 
                alt="123wonder英文科普" 
                style={{ 
                  height: 'clamp(40px, 6vw, 50px)', 
                  width: 'auto',
                  maxWidth: '100%'
                }} 
              />
            </div>
          </div>
        </div>
      </nav>

      <div style={{ flex: 1, overflowY: 'auto', padding: '64px 0', backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '30px',
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
          }}>
            <div style={{ 
              width: '120px', 
              height: '120px', 
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '48px',
              fontWeight: 'bold',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              {user?.username?.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex: 1 }}>
              <h1 style={{ 
                marginBottom: '10px', 
                color: '#1a2b4c',
                fontSize: '2rem'
              }}>
                {user?.fullName || user?.username}
              </h1>
              <p style={{ 
                marginBottom: '20px', 
                color: '#6c757d',
                fontSize: '1.1rem'
              }}>
                {user?.phone}
              </p>
              <div style={{ 
                display: 'flex', 
                gap: '30px',
                flexWrap: 'wrap'
              }}>
                <div style={{ 
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  minWidth: '100px'
                }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold',
                    color: '#1976d2',
                    marginBottom: '5px'
                  }}>
                    {user?.totalPoints || 0}
                  </div>
                  <div style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                    积分
                  </div>
                </div>
                <div style={{ 
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  minWidth: '100px'
                }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold',
                    color: '#1976d2',
                    marginBottom: '5px'
                  }}>
                    {user?.streak || 0}
                  </div>
                  <div style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                    连续学习
                  </div>
                </div>
                <div style={{ 
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  minWidth: '100px'
                }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold',
                    color: '#1976d2',
                    marginBottom: '5px',
                    textTransform: 'capitalize'
                  }}>
                    {user?.level}
                  </div>
                  <div style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                    级别
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section style={{ padding: '40px 0' }}>
        <div className="container">
          {message.text && (
            <div style={{ 
              padding: '15px',
              marginBottom: '30px',
              borderRadius: '8px',
              backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
              color: message.type === 'success' ? '#155724' : '#721c24',
              border: `1px solid ${message.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`
            }}>
              {message.text}
            </div>
          )}

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '30px'
          }}>
            <div style={{ 
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '12px',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
            }}>
              <h2 style={{ 
                marginBottom: '24px', 
                color: '#1a2b4c',
                fontSize: '1.5rem',
                fontWeight: '600'
              }}>
                编辑个人资料
              </h2>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    用户名
                  </label>
                  <input
                    type="text"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      backgroundColor: '#f8f9fa',
                      color: '#495057'
                    }}
                    value={user?.username || ''}
                    disabled
                  />
                  <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                    用户名不可更改
                  </small>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    姓名
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      color: '#495057'
                    }}
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="请输入您的姓名"
                  />
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    手机号
                  </label>
                  <input
                    type="tel"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      backgroundColor: '#f8f9fa',
                      color: '#495057'
                    }}
                    value={user?.phone || ''}
                    disabled
                  />
                  <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                    手机号不可更改
                  </small>
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    英语水平
                  </label>
                  <select
                    name="level"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      color: '#495057',
                      backgroundColor: 'white'
                    }}
                    value={formData.level}
                    onChange={handleChange}
                  >
                    <option value="beginner">剑桥一级</option>
                    <option value="intermediate">剑桥二级</option>
                    <option value="advanced">剑桥三级</option>
                    <option value="ket">KET</option>
                    <option value="pet">PET</option>
                    <option value="fce">FCE</option>
                  </select>
                </div>

                <button 
                  type="submit" 
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  disabled={loading}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
                >
                  <FiSave /> 保存更改
                </button>
              </form>
            </div>

            <div style={{ 
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '12px',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
            }}>
              <h2 style={{ 
                marginBottom: '24px', 
                color: '#1a2b4c',
                fontSize: '1.5rem',
                fontWeight: '600'
              }}>
                修改密码
              </h2>
              <form onSubmit={handlePasswordSubmit}>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    当前密码
                  </label>
                  <input
                    type="password"
                    name="currentPassword"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      color: '#495057'
                    }}
                    value={passwords.currentPassword}
                    onChange={handlePasswordChange}
                    placeholder="请输入当前密码"
                    required
                  />
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    新密码
                  </label>
                  <input
                    type="password"
                    name="newPassword"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      color: '#495057'
                    }}
                    value={passwords.newPassword}
                    onChange={handlePasswordChange}
                    placeholder="请输入新密码"
                    required
                  />
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#495057',
                    fontWeight: '500'
                  }}>
                    确认新密码
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      fontSize: '1rem',
                      color: '#495057'
                    }}
                    value={passwords.confirmPassword}
                    onChange={handlePasswordChange}
                    placeholder="请确认新密码"
                    required
                  />
                </div>

                <button 
                  type="submit" 
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  disabled={loading}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
                >
                  <FiLock /> 更新密码
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Profile;
